let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("civw8")).then(() => parcelRequire('92Qej'));